import styled from "@emotion/styled";
import { Box } from "@kaltura/mediaspace-shared-styled";
import { Typography } from "@kaltura/ds-react-components";

export const StyledContainer = styled(Box)(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    color: theme.kaltura.palette.translucent.main,
    [theme.breakpoints.down("md")]: {
        display: "flex",
        justifyContent: "center",
    },
}));

export const NoCounterText = styled(Typography)(({ theme }) => ({
    textTransform: "uppercase",
    letterSpacing: 1,
    marginBottom: theme.spacing(3),
    [theme.breakpoints.down("md")]: {
        textAlign: "center",
    },
    [theme.breakpoints.down("sm")]: {
        marginBottom: theme.spacing(1),
    },
}));
